import { render, staticRenderFns } from "./FeedComponent.vue?vue&type=template&id=5477156c&"
import script from "./FeedComponent.vue?vue&type=script&lang=js&"
export * from "./FeedComponent.vue?vue&type=script&lang=js&"
import style0 from "./FeedComponent.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports